import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visitor-thank-you',
  templateUrl: './visitor-thank-you.component.html',
  styleUrls: ['./visitor-thank-you.component.scss']
})
export class VisitorThankYouComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
